import { store } from '../App';
import { openConfirmDialog } from '../state/utility';

export const askConfirmDelete = (onConfirm: () => void) => {
  return () => store.dispatch(openConfirmDialog(onConfirm, '정말로 삭제하시겠어요?'));
};

export default { askConfirmDelete };
